export default [
  {
    path: "/group-tryout",
    name: "group-tryout",
    component: () => import("@/views/menu/group/tryout.vue"),
    meta: {
      pageTitle: "",
      requireAuth: true,
    },
  },

  {
    path: "/group-event",
    name: "group-event",
    component: () => import("@/views/menu/group/event.vue"),
    meta: {
      pageTitle: "",
      requireAuth: true,
    },
  },
];
